import type { ApiResponse } from '@skylabs-digital/react-proto-kit';

/** Desenvuelve la respuesta cruda del connector de react-proto-kit 3 (unión discriminada por `success`). */
export function unwrap<T>(res: ApiResponse<T>): T {
  if (!res.success) throw new Error(res.message ?? 'Request failed');
  return res.data;
}
